/**
 * Judge.me Cards Carousel overrides.
 * 1) window.__APPS_FIGMA_JUDGE_CSS__ = apps-figma-judge-shadow.css asset URL (theme.liquid).
 * 2) Shadow: <link rel="stylesheet"> (fetch yok — CDN / CORS sessiz hata vermez).
 * 3) Light DOM: aynı link veya style; section içi shopify-app gölgesi yoksa section’a link.
 */
(function () {
  var MARK = 'data-apps-figma-judge';

  function getHref() {
    return typeof window !== 'undefined' && window.__APPS_FIGMA_JUDGE_CSS__
      ? String(window.__APPS_FIGMA_JUDGE_CSS__)
      : '';
  }

  function injectStylesheetLink(root, mode) {
    if (!root) return false;
    var attr = mode === 'light' ? MARK + '-light' : MARK;
    if (root.querySelector('link[' + attr + ']')) return false;
    var href = getHref();
    if (!href) return false;
    var link = document.createElement('link');
    link.setAttribute(attr, '1');
    link.rel = 'stylesheet';
    link.href = href;
    root.appendChild(link);
    return true;
  }

  var lightInjectedSections = new WeakSet();

  /** İki satır sadece küçük ekranda: <br> sınıfı mobilde display:block, masaüstünde none */
  function splitCardsCarouselTitle(el) {
    if (!el || el.nodeType !== 1) return;
    var html = el.innerHTML || '';
    if (html.indexOf('apps-figma-judge-title-break') !== -1) return;
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t) return;
    var m = t.match(/^(.*?customers)\s+(worldwide.*)$/i);
    if (!m) return;
    el.setAttribute('data-apps-figma-judge-title-split', '1');
    el.innerHTML = m[1].trim() + ' <br class="apps-figma-judge-title-break">' + m[2].trim();
  }

  var HEADER_GUTTER =
    'max(1.25rem, calc((100vw - min(100vw, 1272px)) / 2))';
  var CARD_GAP = '10px';
  var VERIFIED_BUYER_LABEL = 'Verified Buyer';

  function getTrackPad() {
    if (typeof window !== 'undefined' && window.innerWidth >= 990) {
      return HEADER_GUTTER;
    }
    return 'max(24px, 1.25rem)';
  }

  function getStarAssetUrl() {
    return typeof window !== 'undefined' && window.__APPS_FIGMA_JUDGE_STAR__
      ? String(window.__APPS_FIGMA_JUDGE_STAR__)
      : '';
  }

  function applyCarouselTrackPadding(root) {
    if (!root || !root.querySelectorAll) return;
    var pad = getTrackPad();
    var selectors =
      '.jdgm-carousel-wrapper .swiper-wrapper, .jdgm-carousel-wrapper .jdgm-row, .jdgm-videos-container';
    var mobile = typeof window !== 'undefined' && window.innerWidth < 990;
    root.querySelectorAll('.jdgm-cards-carousel').forEach(function (carousel) {
      carousel.style.setProperty('--apps-judge-card-gap', CARD_GAP);
      carousel.style.setProperty('--apps-judge-track-pad', pad);
      carousel.querySelectorAll(selectors).forEach(function (track) {
        track.style.setProperty('padding-left', mobile ? '0' : pad, 'important');
        track.style.setProperty('padding-right', '0', 'important');
        track.style.setProperty('gap', CARD_GAP, 'important');
        track.style.setProperty('box-sizing', 'border-box', 'important');
      });
      if (mobile) {
        carousel.querySelectorAll('.jdgm-cards-wrapper').forEach(function (shell) {
          shell.style.setProperty('padding-left', pad, 'important');
          shell.style.setProperty('padding-right', '0', 'important');
          shell.style.setProperty('box-sizing', 'border-box', 'important');
        });
      } else {
        carousel.querySelectorAll('.jdgm-cards-wrapper').forEach(function (shell) {
          shell.style.removeProperty('padding-left');
          shell.style.removeProperty('padding-right');
        });
      }
    });
  }

  function normalizeReviewerInfoRow(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.jdgm-cards-carousel .jdgm-reviewer-info').forEach(function (info) {
      info.style.setProperty('display', 'flex', 'important');
      info.style.setProperty('flex-direction', 'row', 'important');
      info.style.setProperty('flex-wrap', 'nowrap', 'important');
      info.style.setProperty('align-items', 'center', 'important');
      info.style.setProperty('gap', '6px', 'important');
      info.style.setProperty('white-space', 'nowrap', 'important');
      info.querySelectorAll(':scope > *').forEach(function (child) {
        child.style.setProperty('flex', '0 0 auto', 'important');
        child.style.setProperty('width', 'auto', 'important');
        child.style.setProperty('max-width', 'none', 'important');
        child.style.setProperty('display', 'inline-flex', 'important');
        child.style.setProperty('white-space', 'nowrap', 'important');
      });
      info.querySelectorAll('[class*="reviewer-name"]').forEach(function (nameEl) {
        nameEl.style.setProperty('display', 'inline', 'important');
        nameEl.style.setProperty('width', 'auto', 'important');
      });
      var wrap = info.querySelector('.jdgm-verifier-wrapper');
      if (wrap) {
        wrap.style.setProperty('display', 'inline-flex', 'important');
        wrap.style.setProperty('flex-wrap', 'nowrap', 'important');
        wrap.style.setProperty('align-items', 'center', 'important');
        wrap.style.setProperty('gap', '4px', 'important');
        wrap.style.setProperty('column-gap', '4px', 'important');
        wrap.style.setProperty('white-space', 'nowrap', 'important');
      }
    });
  }

  function applyCarouselStarAsset(root) {
    if (!root || !root.querySelectorAll) return;
    var url = getStarAssetUrl();
    if (!url) return;
    var value = 'url("' + url.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '")';
    root.querySelectorAll('.jdgm-cards-carousel').forEach(function (carousel) {
      carousel.style.setProperty('--jdgm-figma-star', value);
    });
  }

  var VERIFIED_LABEL_SELECTOR =
    '.jdgm-verifier__text, .jdgm-carousel-item__verified-text, .jdgm-carousel-item__verified-buyer, [data-apps-figma-verified-label], [class*="verified-text"], [class*="verified-buyer"], .apps-figma-verified-buyer-label';

  function ensureVerifiedBuyerLabels(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.jdgm-cards-carousel .jdgm-reviewer-info').forEach(function (info) {
      var icon = info.querySelector(
        '.jdgm-verifier__icon, .jdgm-carousel-item__verified-icon, [class*="verified-icon"]'
      );
      if (!icon) return;

      var wrap = info.querySelector('.jdgm-verifier-wrapper');
      if (!wrap) {
        wrap = document.createElement('span');
        wrap.className = 'jdgm-verifier-wrapper apps-figma-verifier-wrapper';
      }

      if (icon.parentNode !== wrap) {
        wrap.appendChild(icon);
      }

      var labels = [];
      info.querySelectorAll(VERIFIED_LABEL_SELECTOR).forEach(function (el) {
        if (el === icon || icon.contains(el)) return;
        labels.push(el);
      });

      var label = null;
      labels.forEach(function (el) {
        if (!label && (el.textContent || '').replace(/\s+/g, ' ').trim()) {
          label = el;
        }
      });
      if (!label) {
        label = document.createElement('span');
        label.setAttribute('data-apps-figma-verified-label', '1');
        label.className = 'jdgm-verifier__text apps-figma-verified-buyer-label';
        labels.push(label);
      }

      labels.forEach(function (el) {
        if (el !== label) {
          el.style.setProperty('display', 'none', 'important');
          el.setAttribute('aria-hidden', 'true');
          return;
        }
        if (el.parentNode !== wrap) {
          wrap.appendChild(el);
        }
      });

      if (label.parentNode !== wrap) {
        wrap.appendChild(label);
      }
      if (icon.nextSibling !== label) {
        wrap.appendChild(label);
      }

      var nameEl = info.querySelector('[class*="reviewer-name"], .jdgm-reviewer-name');
      if (nameEl) {
        if (nameEl.nextSibling !== wrap) {
          info.insertBefore(wrap, nameEl.nextSibling);
        }
      } else if (wrap.parentNode !== info) {
        info.appendChild(wrap);
      } else if (info.firstElementChild !== wrap) {
        info.insertBefore(wrap, info.firstElementChild);
      }

      label.setAttribute('data-apps-figma-verified-label', '1');
      label.classList.add('apps-figma-verified-buyer-label');
      label.style.removeProperty('display');
      label.removeAttribute('aria-hidden');
      if (!(label.textContent || '').replace(/\s+/g, ' ').trim()) {
        label.textContent = VERIFIED_BUYER_LABEL;
      }

      wrap.style.setProperty('display', 'inline-flex', 'important');
      wrap.style.setProperty('gap', '4px', 'important');
      wrap.style.setProperty('column-gap', '4px', 'important');
      icon.style.setProperty('width', '11px', 'important');
      icon.style.setProperty('min-width', '11px', 'important');
      icon.style.setProperty('max-width', '11px', 'important');
      icon.style.setProperty('flex', '0 0 11px', 'important');
      icon.style.setProperty('margin', '0', 'important');
      icon.style.setProperty('padding', '0', 'important');
      label.style.setProperty('margin', '0', 'important');
      label.style.setProperty('padding', '0', 'important');
    });
  }

  function applyDesktopHeaderGutter(root) {
    if (!root || !root.querySelectorAll) return;
    var headers = root.querySelectorAll('.jdgm-cards-carousel .jdgm-header');
    if (!headers.length) return;
    var desktop = typeof window !== 'undefined' && window.innerWidth >= 990;
    headers.forEach(function (header) {
      if (!desktop) {
        header.style.removeProperty('padding-left');
        header.style.removeProperty('padding-right');
        header.style.removeProperty('box-sizing');
        return;
      }
      header.style.setProperty('padding-left', HEADER_GUTTER, 'important');
      header.style.setProperty('padding-right', HEADER_GUTTER, 'important');
      header.style.setProperty('box-sizing', 'border-box', 'important');
    });
  }

  function splitTitlesInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.jdgm-widget.jdgm-cards-carousel .jdgm-title').forEach(splitCardsCarouselTitle);
    root.querySelectorAll('.jdgm-cards-carousel h2.jdgm-title').forEach(splitCardsCarouselTitle);
    root.querySelectorAll('.jdgm-cards-carousel .jdgm-carousel__title').forEach(splitCardsCarouselTitle);
    root.querySelectorAll('.jdgm-cards-carousel .jdgm-carousel-title-and-actions > h2').forEach(splitCardsCarouselTitle);
    applyDesktopHeaderGutter(root);
    applyCarouselTrackPadding(root);
    applyCarouselStarAsset(root);
    ensureVerifiedBuyerLabels(root);
    normalizeReviewerInfoRow(root);
  }

  function splitAllCarouselTitles() {
    splitTitlesInRoot(document);
    document.querySelectorAll('.apps-figma-reviews-shell').forEach(function (shell) {
      splitTitlesInRoot(shell);
    });
    document.querySelectorAll('shopify-app').forEach(function (host) {
      try {
        if (host.shadowRoot) splitTitlesInRoot(host.shadowRoot);
      } catch (e) {}
    });
  }

  function injectStyleIntoSectionLight(sectionEl) {
    if (!sectionEl || lightInjectedSections.has(sectionEl)) return;
    if (sectionEl.querySelector('link[' + MARK + '-light]')) {
      lightInjectedSections.add(sectionEl);
      return;
    }
    if (injectStylesheetLink(sectionEl, 'light')) {
      lightInjectedSections.add(sectionEl);
    }
  }

  function processSection(sectionEl) {
    if (!getHref()) return;
    var hosts = sectionEl.querySelectorAll('shopify-app');
    var anyShadow = false;
    var anyLightJdgm = false;

    hosts.forEach(function (host) {
      try {
        if (host.shadowRoot) {
          anyShadow = true;
          /* jdgm string kontrolü yok: Judge içerik sonradan yüklenir; link erken eklenir */
          injectStylesheetLink(host.shadowRoot, 'shadow');
        } else if (host.querySelector && host.querySelector('.jdgm-cards-carousel, [class*="jdgm"]')) {
          anyLightJdgm = true;
        }
      } catch (e) {}
    });

    if (!anyShadow && anyLightJdgm) {
      injectStyleIntoSectionLight(sectionEl);
    }
  }

  var scanScheduled = false;
  function scanAll() {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(function () {
      scanScheduled = false;
      splitAllCarouselTitles();
      runScan();
    });
  }

  function runScan() {
    if (!getHref()) return;
    var shells = document.querySelectorAll('.apps-figma-reviews-shell');
    if (shells.length) {
      shells.forEach(function (shell) {
        var sec = shell.closest('[id^="shopify-section"]');
        if (sec) processSection(sec);
      });
      return;
    }
    if (typeof window !== 'undefined' && window.__APPS_FIGMA_JUDGE_HOME_FALLBACK__) {
      document.querySelectorAll('[id^="shopify-section"] shopify-app').forEach(function (host) {
        try {
          var sec = host.closest('[id^="shopify-section"]');
          if (!sec) return;
          if (host.shadowRoot) {
            var inner = host.shadowRoot.innerHTML || '';
            if (inner.indexOf('jdgm') !== -1) {
              injectStylesheetLink(host.shadowRoot, 'shadow');
            }
          } else if (host.querySelector && host.querySelector('[class*="jdgm"]')) {
            injectStyleIntoSectionLight(sec);
          }
        } catch (e) {}
      });
    }
  }

  function init() {
    scanAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', scanAll);
  document.addEventListener('shopify:section:select', scanAll);

  var steps = 0;
  var iv = setInterval(function () {
    steps++;
    scanAll();
    if (steps >= 150) clearInterval(iv);
  }, 200);

  [200, 400, 800, 1500, 3000, 6000, 12000, 20000].forEach(function (ms) {
    setTimeout(scanAll, ms);
  });

  try {
    var mo = new MutationObserver(scanAll);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scanAll, 120);
  });
})();